import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@material-ui/core/';
import classNames from 'classnames';
import React from 'react';
import useStyles from './ChowbusInput.style.js';

export default Input;

/**
 * A full text input FormControl in the Chowbus style, inc. label and behavior.
 * Intented to be used with Chowbus Form
 * @see Form.jsx
 * @param {any} props
 */
function Input(props) {
  const classes = useStyles();
  const {
    id,
    passRef,
    inputClass,
    labelClass,
    labelOutlinedClass,
    disabled,
    outlinedClass,
    name,
    onChange,
    onFocus,
    onBlur,
    value,
    error,
    errorMessage,
    fullWidth,
    label,
    placeholder,
    type,
    endAdornment,
    multiline,
    rows,
    margin,
    defaultValue,
    style,
  } = props;

  return (
    <FormControl
      style={style}
      margin={margin || 'normal'}
      error={error}
      classes={{ root: classes.formControl }}
      fullWidth={fullWidth}
      variant='outlined'>
      <InputLabel classes={{ root: classes.label, shrink: classes.shrink, outlined: labelOutlinedClass || '' }} htmlFor={name} className={labelClass || ''}>
        {label || placeholder}
      </InputLabel>
      <OutlinedInput
        id={id}
        name={name}
        inputProps={{
          'aria-label': name,
          'data-testid': name,
          name,
        }}
        value={value}
        onChange={onChange}
        rows={rows}
        multiline={multiline}
        onFocus={onFocus}
        onBlur={onBlur}
        type={type || 'text'}
        inputRef={passRef}
        endAdornment={endAdornment}
        placeholder={label && placeholder}
        disabled={disabled}
        labelWidth={0}
        defaultValue={defaultValue}
        classes={{
          input: classNames(classes.input, inputClass),
          notchedOutline: classNames(classes.notchedOutline, outlinedClass),
        }}
      />
      {error && errorMessage ? <FormHelperText>{errorMessage}</FormHelperText> : null}
    </FormControl>
  );
}
